<template>
  <el-card class="w-100 center">
    <div slot="header" class="cf">
      <span class="f5 fw6">Register account</span>
      <router-link :to="{ name: 'login' }" class="fr f6 link blue hover-hot-pink">Login</router-link>
    </div>

    <el-alert v-if="authError" type="error" :title="authError" show-icon @close="closeAlert()"></el-alert>

    <template v-if="user">
      <p class="mv3 f6 lh-copy mid-gray">Please enter and confirm a new password to complete registration and sign in.</p>

      <el-form :model="user" :rules="rules" ref="form" @submit.native.prevent="submit()">
        <el-form-item label="Name">
          <el-input type="text" v-model="user.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input type="password" v-model="user.password"></el-input>
        </el-form-item>
        <el-form-item label="Confirm password" prop="password_confirmation">
          <el-input type="password" v-model="user.password_confirmation"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">Register</el-button>
        </el-form-item>
      </el-form>
    </template>

    <template v-if="!user">
      <p class="mv3 mb3 f6 lh-copy mid-gray">Registration can't be completed.</p>
    </template>
  </el-card>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    const passwordConfValidator = (rule, value, callback) => {
      if (value !== this.user.password) {
        callback(new Error('must match password'))
      } else {
        callback()
      }
    }
    return {
      token: this.$route.query.token,
      rules: {
        password: [
          { required: true, trigger: 'blur' },
          { min: 8, max: 72, message: 'must be between 8 and 72 characters', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, trigger: 'blur' },
          { validator: passwordConfValidator, trigger: 'blur' }
        ]
      }
    }
  },

  created() {
    this.fetchRegistration(this.token)
      .catch(e => false)
  },

  computed: {
    ...mapState('auth', ['user', 'authError'])
  },

  methods: {
    ...mapActions('auth', ['fetchRegistration', 'register']),

    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const user = _.pickBy(this.user, (v,k) => _.includes(['password', 'password_confirmation'], k))
          this.register({ token: this.token, user })
            .then(() => window.location.assign('/app'))
            .catch(() => false)
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card__header .link {
  margin-top: 2px;
}
</style>